import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

/** button clicked searchPageRightPanelFeedbackSubmitButton */
export const onRightPanelFeedbackSubmitClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
}): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelFeedbackSubmitButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
